import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useCallback, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';
import { CropwiseAiContainer, CropwiseAiTabsEnum } from 'src/pages/cropwise-ai';
import { MediaQuery } from 'theme';

import { FooterComponent } from './footer/footer.component';
import { SiderNavbarMobileComponent } from './sider-navbar/sider-navbar-mobile.component';

const StructureTemplateMobile = () => {
  const isDesktop = useMediaQuery({ minWidth: MediaQuery.screenSizes.desktop });
  const [showNavbar, setShowNavbar] = useState<boolean>(false);
  const [showCropwiseAi, setShowCropwiseAi] = useState<CropwiseAiTabsEnum>(
    CropwiseAiTabsEnum.HIDE,
  );

  const handleMenuClick = useCallback(() => {
    setShowNavbar((current) => !current);
  }, []);

  const handleHomeClick = useCallback(() => {
    setShowNavbar(false);
  }, []);

  const onFeatureClick = useCallback(() => {
    setShowNavbar(false);
  }, []);

  const handleCropwiseAiOpen = useCallback(() => {
    setShowCropwiseAi(CropwiseAiTabsEnum.FULL_SCREEN);
  }, []);

  return (
    <Layout>
      <Layout>
        <Content>
          <Outlet />
        </Content>
        {!isDesktop && (
          <SiderNavbarMobileComponent
            isClosed={!showNavbar}
            onFeatureClick={onFeatureClick}
          />
        )}
      </Layout>
      {!isDesktop && (
        <>
          <FooterComponent
            isNavbarOpen={showNavbar}
            onMenuClick={handleMenuClick}
            onHomeClick={handleHomeClick}
            onCropwiseAiOpen={handleCropwiseAiOpen}
          />
          <CropwiseAiContainer
            showType={showCropwiseAi}
            setShowType={setShowCropwiseAi}
          />
        </>
      )}
    </Layout>
  );
};

export { StructureTemplateMobile };
